<ul>
  @for (t of tabs; track t) {
    <app-content-tab [tab]="t" (onTabClick)="onTabClicked($event)" [ngClass]="{'active-tab': t.id === activeTabId}"></app-content-tab>
  }
</ul>
